import { getTagListThunk } from '../redux/Tag/Tag.thunk';
import { Tag, TagListResponse } from '../redux/ControlPanel/TagControl/TagControl.type';
import { useAppDispatch } from './useAppDispatcher.hook';
import { SelectOptionProps } from '../components/Input/Select.component';

type TagsDataWithPaginate = {
  options: SelectOptionProps[];
  hasMore: boolean;
  additional: { page: number };
};

type UseTagsHook = {
  getSelectList: (search: string, { page }: any) => Promise<TagsDataWithPaginate>;
  getSelectListByIds: (ids: Array<number>) => Promise<Array<SelectOptionProps>>;
};

const useTagsHook = ():UseTagsHook => {
  const dispatch = useAppDispatch();

  return {
    getSelectList: async (
      q: string,
      { page }: any,
    ) => {
      const { payload } = await dispatch(getTagListThunk({ q, page }));
      const { data, pagination } = payload as TagListResponse;
      return {
        options: data.map((item: Tag) => ({
          value: item.id,
          label: item.name,
        })),
        hasMore: pagination.current_page < pagination.last_page,
        additional: {
          page: pagination.current_page + 1,
        },
      };
    },
    getSelectListByIds: async (ids: Array<number>) => {
      const { payload } = await dispatch(getTagListThunk({}));
      const { data } = payload as TagListResponse;
      return data.filter((item: Tag) => ids.includes(item.id)).map((item: Tag) => ({
        value: item.id,
        label: item.name,
      }));
    },
  };
};

export default useTagsHook;
